import React from 'react';
import Component from '../../../ui-components/Component';
import SelectionCard from '../../LandingPageNew/LandingSubComponents/SelectionCard';
import view, {
  propertyType,
  oyoFormView,
  borders,
  validation
} from '../../../Enums';
import Revenue from '../../LandingPageNew/LandingSubComponents/Revenue';
import DropdownMenuLocation from '../../../common/DropDownLocation';
import DropdownMenuMobile from '../../../common/DropdownMenMobileu';
import { dialCode } from '../../../partnerStyles';
import BackIcon from '../../../resources/vectors/BackIcon';
import LandingImages from '../../LandingPageNew/LandingImages';
import { withTranslations } from '../../../HoCs';
import Styles from '../BecomeAnOyoStyles';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { earningPotentialEnabled, hmsSelfOnboardingEnabled, isLifeEnabled } from '../../../config/countryConfig';
import { EVENT_CATEGORIES, EVENT_ACTIONS, logEvent } from '../../../services/Analytics';

class CheckEarningsWidget extends Component {
  
  state = {
    name_border: borders.NORMAL_BORDER,
    location_border: borders.NORMAL_BORDER,
    ph_no_border: borders.NORMAL_BORDER
  };
  
  images = LandingImages;
  styles = Styles;
  render() {
    let gs = this.gs;
    let gc = this.props.gc;
    let guc = this.props.guc;
    let gi = this.gi;

    let flagImage, dial_Code;
    flagImage = {
      ...gs('flag_style'),
      backgroundPosition: '0 -' + this.props.flagPos + 'px'
    };
    dial_Code = dialCode;
    return (
      <div>
        {(this.props.oyoFormMode === oyoFormView.checkEarnings ||
          this.props.oyoFormMode === oyoFormView.homeBasic||
          this.props.oyoFormMode === oyoFormView.lifeBasic ||
          this.props.oyoFormMode === oyoFormView.hmsSelfOnboardingHome)
          &&
          !this.props.disablePropertySelection &&(
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-around',
              width: isLifeEnabled() ? '90%' : '68%',
              paddingLeft: isLifeEnabled() ? '5%' : '15%',
              marginBottom: '10px',
              marginTop: '10px'
            }}
          >
            <SelectionCard
              width={isLifeEnabled() ? '30%' : '42%'}
              height={'45px'}
              viewMode={this.props.viewMode}
              selected={
                this.props.globalData.type_of_property == propertyType.HOTEL
              }
              info_icon={gi('info_icon')}
              type_icon={gi('hotel_icon')}
              tick={gi('green_tick')}
              type_text={guc('Hotel')}
              type_style_tag={'hotel_icon'}
              onClick={() => {
                this.props.globalActions.updatePropertyType(propertyType.HOTEL);
                this.props.changeFormScreen(oyoFormView.checkEarnings);
              }}
            />

            <SelectionCard
              width={isLifeEnabled() ? '32%' : '42%'}
              height={'45px'}
              viewMode={this.props.viewMode}
              selected={
                this.props.globalData.type_of_property == propertyType.HOME
              }
              info_icon={gi('info_icon')}
              type_icon={gi('house_icon')}
              tick={gi('green_tick')}
              type_text={guc('Home')}
              type_style_tag={'house_icon'}
              onClick={() => {
                this.props.globalActions.updatePropertyType(propertyType.HOME);
                hmsSelfOnboardingEnabled() ? this.props.changeFormScreen(oyoFormView.hmsSelfOnboardingHome) : this.props.changeFormScreen(oyoFormView.homeBasic);
              }}
            />
              {isLifeEnabled() && <SelectionCard
                  width={'30%'}
                  height={'45px'}
                  viewMode={this.props.viewMode}
                  selected={
                      this.props.globalData.type_of_property == propertyType.LIFE
                  }
                  type_icon={'/partnerpage/images/pg_icon.svg'}
                  tick={gi('green_tick')}
                  type_text={guc('Life')}
                  type_style_tag={'hotel_icon'}
                  onClick={() => {
                      this.props.globalActions.updatePropertyType(propertyType.LIFE);
                      this.props.changeFormScreen(oyoFormView.lifeBasic);
                  }}
              />}
          </div>
        )}
        
        {this.props.oyoFormMode === oyoFormView.checkEarnings && (
          <div>
            <div
              style={{
                ...gs('big_text_form'),
                marginBottom: '0px',
                textAlign: 'center'
              }}
            >
              {guc('check_your_earn')}
            </div>
          </div>
        )}

        {(this.props.oyoFormMode === oyoFormView.homeBasic ||
          this.props.oyoFormMode == oyoFormView.hotelBasic) && (
          <div>
  
            {this.props.oyoFormMode == oyoFormView.hotelBasic && <BackIcon className={'hover'} onClick={() => {
              this.props.changeFormScreen(oyoFormView.checkEarnings);
            }} style={gs('back')}/>}
            
            <div style={{ ...gs('big_text_form') }}>
              {guc('get_associated')}
            </div>

            <div style={{...gs('form_small_text'),marginTop:'4px'}}>{gc('name')}</div>
            <input
              type="text"
              placeholder={gc('name_placeholder')}
              autoComplete="new-password"
              onChange={e => {
                logEvent(this.props.eventCategory, EVENT_ACTIONS.NAME_ENTERED, e.target.value);
                this.props.globalActions.dataUpdate(
                  'full_name',
                  e.target.value
                );
                this.props.validateOneField(validation.FULL_NAME);
              }}
              onBlur={() => {
                this.setState({
                  name_border: borders.NORMAL_BORDER
                });
              }}
              onFocus={() => {
                this.setState({
                  name_border: borders.ACTIVE_BORDER
                });
              }}
              value={this.props.globalData.formData.full_name}
              className={'removeFocusOutline'}
              style={{
                ...gs('input_form'),
                border: this.props.name_border_validated
                  ? this.state.name_border
                  : borders.RED_BORDER
              }}
            />

            <div style={gs('form_small_text')}>{gc('mobile_number')}</div>

            <div style={gs('mobile_number_container')}>
              <span
                style={gs('cursor_pointer_style')}
                className={'cursorPointer'}
                onClick={this.props.changeMobile}
              >
                <img style={gs('down_arrow_style')} src={gi('down_arrow')} />
              </span>

              <span
                style={{
                  ...flagImage,
                  ...gs('flag_image_style')
                }}
                className={'cursorPointer'}
                onClick={this.props.changeMobile}
              />
              <input
                placeholder={gc('mobile_number_placeholder')}
                autoComplete="new-password"
                onChange={this.props.onChangeMobileInput}
                value={this.props.resultant_ph_no}
                className={'removeFocusOutline'}
                style={{
                  ...gs('input_form'),
                  padding: '10px 0px 10px 61px',
                  width: this.props.viewMode == view.DESKTOP ? '82%' : '86%',
                  border: this.props.ph_no_border_validated
                    ? this.state.ph_no_border
                    : borders.RED_BORDER
                }}
                onFocus={() => {
                  this.setState({
                    ph_no_border: borders.ACTIVE_BORDER
                  });
                }}
                onBlur={() => {
                  this.setState({
                    ph_no_border: borders.NORMAL_BORDER
                  });
                }}
              />
              {this.props.showDropdownMobile && (
                <DropdownMenuMobile
                  id={'locDrop'}
                  viewSize={'Desktop'}
                  k={this.props.flag}
                  topPos={'4px'}
                  divWidth={'100%'}
                  divTop={'48px'}
                />
              )}
            </div>
          </div>
        )}

        <div style={gs('location_container')}>
          <div style={gs('form_small_text')}>{gc('location')}</div>
          
          <input
            placeholder={gc('location_placeholder')}
            type="text"
            autoComplete="new-password"
            onChange={this.props.onLocationTextUpdate}
            value={this.props.globalData.location}
            className={'removeFocusOutline'}
            style={{
              ...gs('input_form'),
              border: this.props.location_border_validated
                ? this.state.location_border
                : borders.RED_BORDER
            }}
            onFocus={() => {
              this.setState({
                location_border: borders.ACTIVE_BORDER
              });
            }}
            onBlur={() => {
              this.setState({
                location_border: borders.NORMAL_BORDER
              });
            }}
          />
          <ClickAwayListener
              onClickAway={this.props.handleClickAway}
          >
            <div>
          {this.props.showDropdown  && (
            <DropdownMenuLocation
              top={'73px'}
              options={this.props.dropDownOptions}
              style={{}}
              change={this.props.onClickDropdown}
            />
          )}
            </div>
          </ClickAwayListener>
        </div>
        <div
            style={{
              ...gs('form_small_text'),
              color: 'red',
              lineHeight: '1.1',
              height: '13px'
            }}
        >
          {this.props.location_error}
        </div>
        

        {(this.props.oyoFormMode === oyoFormView.checkEarnings ||
        this.props.oyoFormMode === oyoFormView.lifeBasic) &&
          earningPotentialEnabled()  && (
            <Revenue
              validateOneField={this.props.validateOneField}
              amount={this.props.amount}
              viewMode={this.props.viewMode}
              eventCategory={EVENT_CATEGORIES.PARTNER_PAGE_LANDING_FORM}
              eventAction={EVENT_ACTIONS.STEP_1_ROOM_COUNT_ENTERED}
              formMode={this.props.oyoFormMode}
            />
          )}
      </div>
    );
  }
}

export default withTranslations(CheckEarningsWidget);
